import { isLoggedIn } from '~/lib/utils/common_utils';
import { detectAndConfirmSensitiveTokens } from '../../../lib/utils/secret_detection.js?vue3';
import DiffDiscussions from './diff_discussions.vue?vue3';
import NoteForm from './note_form.vue?vue3';
import NoteSignedOutWidget from './note_signed_out_widget.vue?vue3';
export default {
    name: 'CommitTimeline',
    components: {
        DiffDiscussions,
        NoteForm,
        NoteSignedOutWidget
    },
    inject: {
        store: {
            type: Object
        },
        userPermissions: {
            type: Object
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    methods: {
        async saveNote (noteText) {
            if (!noteText) return;
            const confirmSubmit = await detectAndConfirmSensitiveTokens({
                content: noteText
            });
            if (!confirmSubmit) return;
            await this.store.createNewDiscussion({
                note: noteText
            });
        }
    }
};
